"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlForBlogItem = exports.BLOG_POSTS = void 0;
const CgpEvolutionPost_1 = __importDefault(require("./2023/cgp-evolution/CgpEvolutionPost"));
const CgpIntroPost_1 = __importDefault(require("./2023/cgp-intro/CgpIntroPost"));
const CgpIrisPost_1 = __importDefault(require("./2023/cgp-solve-iris/CgpIrisPost"));
const CgpAsyncPost_1 = __importDefault(require("./2024/cgp-async/CgpAsyncPost"));
const CgpSolveTimePost_1 = __importDefault(require("./2024/cgp-solve-time/CgpSolveTimePost"));
const MergingCrossoverPost_1 = __importDefault(require("./2024/merging-crossover/MergingCrossoverPost"));
const SantaFePost_1 = __importDefault(require("./2024/santa-fe/SantaFePost"));
const SantaFeRegularPost_1 = __importDefault(require("./2024/santa-fe-regular/SantaFeRegularPost"));
const SantaFeRecurrentPost_1 = __importDefault(require("./2024/santa-fe-recurrent/SantaFeRecurrentPost"));
const RecurrentCGPPost_1 = __importDefault(require("./2024/recurrent-cgp/RecurrentCGPPost"));
const FullPassRCGPPost_1 = __importDefault(require("./2024/full-pass-rcgp/FullPassRCGPPost"));
const NArmedBanditPost_1 = __importDefault(require("./2024/n-armed-bandit/NArmedBanditPost"));
const EvBasicPost_tsx_1 = __importDefault(require("./2024/ev-basic/EvBasicPost.tsx"));
exports.BLOG_POSTS = [
    CgpIntroPost_1.default,
    CgpEvolutionPost_1.default,
    CgpIrisPost_1.default,
    CgpAsyncPost_1.default,
    MergingCrossoverPost_1.default,
    CgpSolveTimePost_1.default,
    SantaFePost_1.default,
    SantaFeRegularPost_1.default,
    SantaFeRecurrentPost_1.default,
    RecurrentCGPPost_1.default,
    FullPassRCGPPost_1.default,
    // SerengetiWorldPost,
    NArmedBanditPost_1.default,
    EvBasicPost_tsx_1.default
];
function urlForBlogItem(blogItem) {
    const dateBit = `${blogItem.publishDate.getFullYear()}-${blogItem.publishDate.getMonth() + 1}`;
    const urlSafeTitle = `${blogItem.title.toLowerCase().replace(/ /g, "-")}`;
    return `/blog/${dateBit}-${urlSafeTitle}`;
}
exports.urlForBlogItem = urlForBlogItem;
